/**
 * Person count selector component for training services
 */

import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useTranslation } from "@/hooks/useTranslation";

interface PersonCountSelectorProps {
  value: "1" | "2" | "3-6" | null;
  onChange: (value: "1" | "2" | "3-6") => void;
}

export function PersonCountSelector({
  value,
  onChange,
}: PersonCountSelectorProps) {
  const { t } = useTranslation();
  const options = [
    { id: "1" as const, label: "1 Person" },
    { id: "2" as const, label: "2 Persons" },
    { id: "3-6" as const, label: "3-6 Persons" },
  ];

  return (
    <div className="space-y-2">
      <Label>{t("attendance:dialog.personCount")}</Label>
      <div className="flex gap-2">
        {options.map(option => (
          <Button
            key={option.id}
            type="button"
            variant={value === option.id ? "default" : "outline"}
            className="flex-1"
            onClick={() => onChange(option.id)}
          >
            {option.label}
          </Button>
        ))}
      </div>
    </div>
  );
}
